// Scene
import { ETextParamType_OperateCanvas, ETextParamType_SceneItem, worldViewerWindow } from './const';
// OperateCanvas
/**
 * @remarks
 * JRWorld_web->heliodor_front.jsにて参照
 * JRWorld_web->heliodor_skyway.jsにて参照
 * XRWorldIngame->heliodor_front.jsにて参照
 * XRWorldIngame->heliodor_xrw_interface.jsにて参照
 * XRWorldIngame->heliodor_skyway.jsにて参照
 * heliodor_front, skywayから呼出があるため、global関数としておいておく
 * @param layoutName
 * @param show
 */ worldViewerWindow.hel_canvas_SetLayoutShow = (layoutName, show)=>{
    worldViewerWindow.hel_setText(ETextParamType_OperateCanvas, 'SetLayoutShow,' + layoutName + ',' + (show ? 'true' : 'false'));
};
/**
 * @remarks
 * JRWorld_web->heliodor_front.jsにて参照
 * JRWorld_web->heliodor_skyway.jsにて参照
 * XRWorldIngame->heliodor_xrw_interface.jsにて参照
 * XRWorldIngame->heliodor_skyway.jsにて参照
 * heliodor_front, xrw_interface, skywayから呼出があるため、global関数としておいておく
 * @param layoutName
 * @param guiName
 * @param show
 */ worldViewerWindow.hel_canvas_SetGUIShow = (layoutName, guiName, show)=>{
    worldViewerWindow.hel_setText(ETextParamType_OperateCanvas, 'SetGUIShow,' + layoutName + ',' + guiName + ',' + (show ? 'true' : 'false'));
};
/**
 * @remarks
 * JRWorld_web->heliodor_front.jsにて参照
 * XRWorldIngame->heliodor_xrw_interface.jsにて参照
 * heliodor_front, xrw_interface, skyway, skyway_rcpから呼出があるため、global関数としておいておく
 * @param layoutName
 * @param guiName
 * @param text
 */ worldViewerWindow.hel_canvas_SetGUIText = (layoutName, guiName, text)=>{
    worldViewerWindow.hel_setText(ETextParamType_OperateCanvas, 'SetGUIText,' + layoutName + ',' + guiName + ',' + text);
};
/**
 * @remarks
 * JRWorld_web->heliodor_front.jsにて参照
 * heliodor_front.jsから参照あるためglobal関数としておいておく
 * @param ItemName
 * @param NodeName
 * @param Show
 */ worldViewerWindow.hel_scene_SetShowNode = (ItemName, NodeName, Show)=>{
    worldViewerWindow.hel_setText(ETextParamType_SceneItem, 'SetShowNode,' + ItemName + ',' + NodeName + ',' + (Show ? '1' : '0'));
};
// TogggleDefaultで設定された値に戻す
/**
 * @remarks
 * JRWorld_web->heliodor_front.jsにて参照
 * XRWorldIngame->heliodor_xrw_interface.jsにて参照
 * heliodor_front.jsから参照あるためglobal関数としておいておく
 * @param ToggleName
 */ worldViewerWindow.hel_canvas_ResetToggleDefault = (ToggleName)=>{
    let layoutName = 'DummyLayout'; //構文ルール上必要
    worldViewerWindow.hel_setText(ETextParamType_OperateCanvas, 'ToggleDefault,' + layoutName + ',' + ToggleName);
};
// Toggleを切り替える
/**
 * @remarks
 * JRWorld_web->heliodor_front.jsにて参照
 * XRWorldIngame->heliodor_xrw_interface.jsにて参照
 * heliodor_front.jsから参照あるためglobal関数としておいておく
 * @param ToggleName
 */ worldViewerWindow.hel_canvas_ToggleChange = (ToggleName)=>{
    let layoutName = 'DummyLayout'; //構文ルール上必要
    worldViewerWindow.hel_setText(ETextParamType_OperateCanvas, 'ToggleChange,' + layoutName + ',' + ToggleName);
};
/**
 * @remarks
 * JRWorld_web->heliodor_front.jsにて参照
 * XRWorldIngame->heliodor_xrw_interface.jsにて参照
 * heliodor_front, xrw_interface.jsから呼出があるため、global関数としておいておく
 * @param layoutName
 * @param guiName
 * @param fileName
 */ worldViewerWindow.hel_canvas_SetGUIImage = (layoutName, guiName, fileName)=>{
    worldViewerWindow.hel_setText(ETextParamType_OperateCanvas, 'SetGUIImage,' + layoutName + ',' + guiName + ',' + fileName);
};
